import jDashKurikulum from '@/views/dashboard/jDashKurikulum';

import jDokumenSaya from '@/views/kurikulum/admin-pembelajaran/jDokumenSaya';
import jAdminPembelajaranList from '@/views/kurikulum/admin-pembelajaran/jAdminPembelajaranList';
import jAdminPembelajaranCreate from '@/views/kurikulum/admin-pembelajaran/jAdminPembelajaranCreate';
import jAdminPembelajaranUpdate from '@/views/kurikulum/admin-pembelajaran/jAdminPembelajaranUpdate';
import jAdminPembelajaranListApp from '@/views/kurikulum/admin-pembelajaran/approver/jAdminPembelajaranList';

import jSuratSaya from '@/views/kurikulum/admin-surat/jSuratSaya';
import jAdminSuratList from '@/views/kurikulum/admin-surat/jAdminSuratList';
import jAdminSuratCreate from '@/views/kurikulum/admin-surat/jAdminSuratCreate';
import jAdminSuratUpdate from '@/views/kurikulum/admin-surat/jAdminSuratUpdate';
import jAdminSuratListApp from '@/views/kurikulum/admin-surat/approver/jAdminSuratList';
import jAdminSuratReportList from '@/views/kurikulum/admin-surat/jAdminSuratReportList';

import jSemuaLaporan from '@/views/kurikulum/laporan-walikelas/jSemuaLaporan';
import jLaporanWaliKelasList from '@/views/kurikulum/laporan-walikelas/jLaporanWaliKelasList';
import jLaporanWaliKelasCreate from '@/views/kurikulum/laporan-walikelas/jLaporanWaliKelasCreate';
import jLaporanWaliKelasUpdate from '@/views/kurikulum/laporan-walikelas/jLaporanWaliKelasUpdate';

import jKepegawaianList from '@/views/kurikulum/kepegawaian/jKepegawaianList';
import jKepegawaianCreate from '@/views/kurikulum/kepegawaian/jKepegawaianCreate';
import jKepegawaianUpdate from '@/views/kurikulum/kepegawaian/jKepegawaianUpdate';
import jKepegawaianReport from '@/views/kurikulum/kepegawaian/jKepegawaianReport';

import jTahunAjaran from '@/views/kurikulum/admin-kelas/jTahunAjaran';
import jKelas from '@/views/kurikulum/admin-kelas/jKelas';
import jBagiKelas from '@/views/kurikulum/admin-kelas/jBagiKelas';
import jPoin from '@/views/kurikulum/poin/jPoin';

import auth from '@/middleware/auth';
import log from '@/middleware/log';

export default [
  {
    path: '/dashboard/kurikulum',
    name: 'jDashKurikulum',
    component: jDashKurikulum,
    meta: {
      title: 'Dashboard Kurikulum',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Administrasi Pembelajaran --------------------------------------
  {
    path: '/admin-pembelajaran/dokumen-saya',
    name: 'jDokumenSaya',
    component: jDokumenSaya,
    meta: {
      title: 'Administrasi Pembelajaran',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-pembelajaran/requester',
    name: 'jAdminPembelajaranList',
    component: jAdminPembelajaranList,
    meta: {
      title: 'Administrasi Pembelajaran',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-pembelajaran/requester/create/:category_id',
    name: 'jAdminPembelajaranCreate',
    component: jAdminPembelajaranCreate,
    meta: {
      title: 'Administrasi Pembelajaran',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-pembelajaran/:role/detail/:status/:id',
    name: 'jAdminPembelajaranUpdate',
    component: jAdminPembelajaranUpdate,
    meta: {
      title: 'Administrasi Pembelajaran',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-pembelajaran/:role/detail/:id',
    name: 'jAdminPembelajaranUpdate',
    component: jAdminPembelajaranUpdate,
    meta: {
      title: 'Administrasi Pembelajaran',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-pembelajaran/approver',
    name: 'jAdminPembelajaranListApp',
    component: jAdminPembelajaranListApp,
    meta: {
      title: 'Administrasi Pembelajaran',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Administrasi Surat Menyurat --------------------------------------
  {
    path: '/admin-surat/surat-saya',
    name: 'jSuratSaya',
    component: jSuratSaya,
    meta: {
      title: 'Administrasi Surat Menyurat',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-surat/requester',
    name: 'jAdminSuratList',
    component: jAdminSuratList,
    meta: {
      title: 'Administrasi Surat Menyurat',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-surat/requester/create/:category_id',
    name: 'jAdminSuratCreate',
    component: jAdminSuratCreate,
    meta: {
      title: 'Administrasi Surat Menyurat',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-surat/:role/detail/:status/:id',
    name: 'jAdminSuratUpdate',
    component: jAdminSuratUpdate,
    meta: {
      title: 'Administrasi Surat Menyurat',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-surat/:role/detail/:id',
    name: 'jAdminSuratUpdate',
    component: jAdminSuratUpdate,
    meta: {
      title: 'Administrasi Surat Menyurat',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-surat/approver',
    name: 'jAdminSuratListApp',
    component: jAdminSuratListApp,
    meta: {
      title: 'Administrasi Surat Menyurat',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-surat/report',
    name: 'jAdminSuratReportList',
    component: jAdminSuratReportList,
    meta: {
      title: 'Report Administrasi Surat Menyurat',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Laporan Wali Kelas --------------------------------------
  {
    path: '/laporan-walikelas/laporan-saya',
    name: 'jLaporanWaliKelasList',
    component: jLaporanWaliKelasList,
    meta: {
      title: 'Laporan Wali Kelas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/laporan-walikelas/requester/create',
    name: 'jLaporanWaliKelasCreate',
    component: jLaporanWaliKelasCreate,
    meta: {
      title: 'Laporan Wali Kelas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/laporan-walikelas/:role/detail/:status/:id',
    name: 'jLaporanWaliKelasUpdate',
    component: jLaporanWaliKelasUpdate,
    meta: {
      title: 'Laporan Wali Kelas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/laporan-walikelas/semua-laporan',
    name: 'jSemuaLaporan',
    component: jSemuaLaporan,
    meta: {
      title: 'Laporan Wali Kelas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Kepegawaian --------------------------------------
  {
    path: '/kepegawaian',
    name: 'jKepegawaianList',
    component: jKepegawaianList,
    meta: {
      title: 'Kepegawaian',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/kepegawaian/create',
    name: 'jKepegawaianCreate',
    component: jKepegawaianCreate,
    meta: {
      title: 'Kepegawaian',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/kepegawaian/detail/:id',
    name: 'jKepegawaianUpdate',
    component: jKepegawaianUpdate,
    meta: {
      title: 'Kepegawaian',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/update-profile/:id/:module',
    name: 'jKepegawaianUpdate',
    component: jKepegawaianUpdate,
    meta: {
      title: 'Kepegawaian',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/kepegawaian/report',
    name: 'jKepegawaianReport',
    component: jKepegawaianReport,
    meta: {
      title: 'Kepegawaian',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  // Administrasi Kelas --------------------------------------
  {
    path: '/admin-kelas',
    name: 'jTahunAjaran',
    component: jTahunAjaran,
    meta: {
      title: 'Administrasi Kelas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/data-tahunajaran',
    name: 'jTahunAjaran',
    component: jTahunAjaran,
    meta: {
      title: 'Data Tahun Ajaran',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-kelas/kelas/:id',
    name: 'jKelas',
    component: jKelas,
    meta: {
      title: 'Administrasi Kelas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/data-kelas',
    name: 'jKelas',
    component: jKelas,
    meta: {
      title: 'Data Kelas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/data-bagi-kelas',
    name: 'jBagiKelas',
    component: jBagiKelas,
    meta: {
      title: 'Data Bagi Kelas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-kelas/bagi-kelas/:idTahun/:idKelas',
    name: 'jBagiKelas',
    component: jBagiKelas,
    meta: {
      title: 'Administrasi Kelas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/data-poin',
    name: 'jPoin',
    component: jPoin,
    meta: {
      title: 'Data Poin',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterKurikulum.js